import { Amplify } from "aws-amplify";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { AuthedRouterPage } from "./pages/authed/AuthedRouterPage";
import config from './config'

Amplify.configure(config.Amplify);

/**
 * App Component
 * 
 * Main application component that sets up routing and authentication.
 * Configures AWS Amplify and provides the main router structure for the application.
 * 
 * Features:
 * - AWS Amplify configuration
 * - React Router setup
 * - Authentication routing
 * - Single-page application structure
 * 
 * @returns {JSX.Element} The main application component
 */
export default function App() {
  return (
    <Router>
      <div>
        <Switch>
          <Route path="/">
            <AuthedRouterPage />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}
